import { useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useUiStore, type NavSegment } from '@/stores/useUiStore'

interface BackToHomeProps {
  /** The home segment the chevron returns to: a thread is an agent, any other screen a page. */
  segment?: NavSegment
  /** A parent screen to return to instead of home (a Settings page's list). */
  to?: string
}

/** Mobile back chevron to the home screen with the matching Agents | Pages segment selected. */
export function BackToHome({ segment = 'pages', to }: BackToHomeProps) {
  const navigate = useNavigate()
  const setNavSegment = useUiStore((state) => state.setNavSegment)

  return (
    <Button
      variant="ghost"
      size="icon-touch"
      className="shrink-0 md:hidden"
      onClick={() => {
        if (to) {
          navigate(to)
          return
        }
        setNavSegment(segment)
        navigate('/chat')
      }}
      aria-label={to ? 'Back' : 'Back to home'}
      data-testid="back-to-home"
    >
      <ChevronLeft className="size-5" />
    </Button>
  )
}
